import type { JSX } from 'react';
import { Section } from './Section';

export const Footer = (): JSX.Element => {
  return (
    <Section background='dark' paddingY='small' maxWidth='medium'>
      <p className='text-center'>© 2025 WOZ Bezwaarhulp. Gemaakt voor het helpen van burgers bij WOZ-bezwaren.</p>
    </Section>
  );
};
